import { SecurityAlertMedia, SecurityAlertRaised } from "@lvt/security-alerts-notification-service-client";


export interface AlertMedia {
    cameraId: number;
    cameraRole: CameraRole;
    sensorId: number;
    mimeType: string;
    mediaTimestamp: string;
    url: string;
}

export interface TimestampCameraMedia {
    timestamp: string;
    cameraMediaList: CameraAlertMedia[];
}

export interface ImageVideoTuple {
    imageMedia?: AlertMedia; //Can be optional if video media loads before image
    videoMedia?: AlertMedia;
}

export interface CameraAlertMedia {
    cameraId: number;
    media: ImageVideoTuple;
    //Error state if no
}

export interface Alert {
    alertId: string;
    alertType?: AlertType;
    alertSubject?: AlertSubject;
    cameraId: number;
    cameraRole?: CameraRole;
    alertTimestamp: string;
    confidence?: number;
    clientId: number;
    clientName?: string;
    locationId: number;
    locationName?: string;
    locationTimezone?: string;
    liveUnitId: number;
    liveUnitName?: string;
    coordinates?: [number, number]; // [longitude, latitude]
    state: "unresolved" | "resolved" | "resolving";
    media: AlertMedia[];
    serial?: string;
}

// API might return a type that isn't here, but these are the expected values.
export enum AlertType {
    LowVoltageDisconnect = "lowvoltagedisconnect",
    Powerloss = "powerloss",
    MastMovement = "mastmovement",
    BaseEntry = "baseentry",
    HeadEntry = "headentry",
    Intrusion = "intrusion",
    Loitering = "loitering",
    Gunshot = "gunshot",
    Fire = "fire",
    Test = "Test",
    Other = "other",
}

// API might return a type that isn't here, but these are the expected values.
export enum AlertSubject {
    Person = "person",
    Vehicle = "vehicle",
    Object = "object",
}

export interface ResolvedAlert {
    alertId: string;
    tags?: string[];
    note?: string;
}

export enum CameraRole {
    Right = "Right",
    Left = "Left",
    Primary = "Primary",
    Radar = "Radar",
    None = "None",
}

export const raisedNotificationToAlert = (securityAlertRaised: SecurityAlertRaised): Alert => ({
    ...securityAlertRaised,
    alertType: securityAlertRaised.alertType as AlertType,
    alertSubject: securityAlertRaised.alertSubject as AlertSubject,
    cameraRole: securityAlertRaised.cameraRole as CameraRole,
    cameraId: parseInt(securityAlertRaised.cameraId),
    clientId: parseInt(securityAlertRaised.clientId),
    locationId: parseInt(securityAlertRaised.locationId),
    liveUnitId: parseInt(securityAlertRaised.liveUnitId),
    // media will always be empty when coming from the notification since
    // the alert media hasn't been uploaded yet
    media: [],
});

export const raisedNotificationToMedia = (media: SecurityAlertMedia): AlertMedia => ({
    ...media,
    cameraId: parseInt(media.cameraId),
    cameraRole: media.cameraRole as CameraRole,
    sensorId: parseInt(media.sensorId),
});

export const sortAlerts = (a: Alert, b: Alert) => {
    const aDate = new Date(a.alertTimestamp);
    const bDate = new Date(b.alertTimestamp);

    if (aDate === bDate) return 0;

    if (aDate > bDate) return -1;

    return 1;
};
